import { SET_CUSTOMER_LOCATION_PHONE } from 'actions';
import { IPhonePartial } from 'typings';

export function setCustomerLocationPhone(customerLocationPhone: IPhonePartial) {
  return { customerLocationPhone, type: SET_CUSTOMER_LOCATION_PHONE };
}
